import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { PasslyTab, PasslyTabs } from '@app/components';
import SwipeableViews from 'react-swipeable-views';

interface IProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

export function PasslyTabContent(props: IProps) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component='div'
            hidden={value !== index}
            id={index}
            {...other}
        >
            <Box> {children} </Box>
        </Typography>
    );
}

export const TabDemo = () => {
    const [tabIndex, setTabIndex] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabIndex(newValue);
    };

    const handleChangeIndex = (index: number) => {
        setTabIndex(index);
    };

    return (
        <>
            <PasslyTabs
                value={tabIndex}
                onChange={handleChange}
            >
                <PasslyTab label={'Label One'} />
                <PasslyTab label={'Label Two'} />
                <PasslyTab label={'Label Three'} />
                {false && <PasslyTab label={'Label Four'} />}
            </PasslyTabs>
            <SwipeableViews
                index={tabIndex}
                onChangeIndex={handleChangeIndex}
            >
                <PasslyTabContent value={tabIndex} index={0}>
                    Item One
                </PasslyTabContent>
                <PasslyTabContent value={tabIndex} index={1}>
                    Item Two
                </PasslyTabContent>
                <PasslyTabContent value={tabIndex} index={2}>
                    Item Three
                </PasslyTabContent>
                {false &&
                    <PasslyTabContent value={tabIndex} index={2}>
                        Item four
                    </PasslyTabContent>
                }
            </SwipeableViews>
        </>
    );
};